var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plr-16 pt-20"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('loading',{attrs:{"loadFlag":_vm.loadFlag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }